'use client';

import { HOME_CARD_FRAGMENT } from '@/gql/fragments/entryCards.gql';
import { withFragment } from '@liquorice/gql-utils';
import { excludeEmptyTypedElements } from '@liquorice/utils';
import PageHeaderRoot from './PageHeaderRoot';

import HeroItems from '../HeroItems';
import './PageHeader.Home.css';

const PageHeaderHome = withFragment(HOME_CARD_FRAGMENT, (data) => {
  if (!data) return null;

  const heroItems = excludeEmptyTypedElements(data.heroItems);

  return <PageHeaderRoot variant="home" beforeContainer={<HeroItems data={heroItems} />} />;
});

export default PageHeaderHome;
